import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { TextGateway } from './text.gateway';
import { firstValueFrom } from 'rxjs';
import {
  DEFAULT_APP_TEXTS,
  EEntityType,
  ERelationType,
  ETextType,
  INormalText,
} from '@web/dtos';
import { IApiResponse } from '@web/shared-types';

@Injectable({
  providedIn: 'root',
})
export class AppTextStore {
  private readonly gateway: TextGateway = new TextGateway();

  readonly #textResource: ResourceRef<IApiResponse<INormalText[]> | undefined> =
    resource({
      loader: (): Promise<IApiResponse<INormalText[]>> => {
        return firstValueFrom(this.gateway.get(ETextType.App));
      },
    });

  readonly isLoading: Signal<boolean> = computed(() =>
    this.#textResource.isLoading()
  );
  readonly texts: Signal<INormalText[]> = computed((): INormalText[] =>
    this.#textResource.hasValue()
      ? (this.#textResource.value()?.data ?? DEFAULT_APP_TEXTS)
      : DEFAULT_APP_TEXTS
  );

  readonly buttonText: Signal<INormalText[]> = computed(() => {
    return this.texts().filter(
      (ticket: INormalText) =>
        ticket.entityType === EEntityType.ticketButton &&
        ticket.relationType === ERelationType.button
    );
  });

  updateNormalText(query: INormalText[]): void {
    this.#textResource.update((): IApiResponse<INormalText[]> => {
      return {
        data: query,
      };
    });
  }

  save(query: INormalText[]): void {
    firstValueFrom(this.gateway.save(query)).then(
      (result: IApiResponse<INormalText[]>): void => {
        if (result && result.data) {
          this.updateNormalText(result.data);
        }
      }
    );
  }

  reload(): void {
    this.#textResource.reload();
  }
}
